import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { REDUCER_TYPES } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FILE_RESPONSE } from './interfaces/file-response.enum';
import { MassEnrollmentFile } from './interfaces/mass-enrollment-file.interface';
import { MassEnrollmentUploadService } from './services/mass-enrollment-upload.service';

@Component({
    selector: 'app-mass-enrollment',
    templateUrl: './mass-enrollment.component.html',
    styleUrls: ['./mass-enrollment.component.scss'],
    standalone: false
})
export class MassEnrollmentComponent implements OnInit {

  @Input() cardOneLabel: string;
  @Input() cardOneSubtitle: string;
  @Input() cardOneButtonLabel: string;
  @Input() cardTwoLabel: string;
  @Input() cardTwoSubtitle: string;
  @Input() cardThreeLabel: string;
  @Input() cardThreeSubtitle: string;
  @Input() cardThreeButtonLabel: string;
  @Input() brokerTemplatePath: string;
  @Input() showCardOne: string;
  @Input() showCardTwo: string;
  @Input() showCardThree: string;
  @Input() serviceFailureMessage: string;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;

  brokerTemplate: string;
  displayCardOne: boolean;
  displayCardTwo: boolean;
  displayCardThree: boolean;

  loginId: string;
  displayedColumns: string[] = [
    'filename',
    'dateTime',
    'message'
  ];

  dataSource: MatTableDataSource<MassEnrollmentFile>;

  fileNameFilter = new FormControl('');;
  dateFilter = new FormControl('');
  statusFilter = new FormControl('');

  filterValues = {
    filename: '',
    dateTime: '',
    message: ''
  }

  showStatusBox: boolean;
  statusText: string;
  showSpinner: boolean;

  constructor(
    private massEnrollmentUploadService: MassEnrollmentUploadService,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  async ngOnInit() {

    const USER_INFO_STATE_NAME = `${REDUCER_TYPES.APPLICATION_STATE}.${LOGIN_INFO_REDUCER_NAME}`;
    const userInfoState: UserInfoStateStructure = this.reducerUtilityService.getGlobalStateItem(USER_INFO_STATE_NAME);
    this.loginId = userInfoState.userId;

    if (this.showCardOne === "true") {
      this.displayCardOne = true;
    }
    if (this.showCardTwo === "true") {
      this.displayCardTwo = true;
    }
    if (this.showCardThree === "true") {
      this.displayCardThree = true;
    }

    await this.getMassEnrollmentStatus(); 
    this.getFilterSubscriptions();
  }

  async getMassEnrollmentStatus(): Promise<void> {
    const response = await this.massEnrollmentUploadService.retrieveFilesByLoginId(this.loginId);
    const responsePayload: MassEnrollmentFile[] = response['payload'];
    this.transformResponseToDataSource(responsePayload);
  }

  transformResponseToDataSource(data: MassEnrollmentFile[]) {
    this.dataSource = new MatTableDataSource<MassEnrollmentFile>(data['files']);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
  }

  downloadBrokerTemplate() {
    window.open(this.brokerTemplatePath, '_blank')
  }

  async handleFileInput(files: FileList): Promise<void> {
    this.showSpinner = true;

    try {
      let file = files.item(0);
      const response = await this.massEnrollmentUploadService.uploadFile(file, this.loginId);
      this.displayStatusMessage(response.payload.message);
      await this.getMassEnrollmentStatus();
      this.showSpinner = false;
    } catch (error) {
      this.showSpinner = false;
      this.displayStatusMessage(this.serviceFailureMessage);
      console.error('Error: ', error);
      throw error;
    }
  }

  uploadSuccess(message: string) {

    if (message.toLowerCase().includes(FILE_RESPONSE.VALIDATED)) {
      return true;
    } else {
      return false;
    }
  }

  displayStatusMessage(responseMessage: string) {
    this.showStatusBox = true;
    this.statusText = responseMessage;
  }

  getFilterSubscriptions() {
    this.fileNameFilter.valueChanges.subscribe(
      filename => {
        this.filterValues.filename = filename.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.dateFilter.valueChanges.subscribe(
      dateTime => {
        this.filterValues.dateTime = dateTime.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.statusFilter.valueChanges.subscribe(
      message => {
        this.filterValues.message = message.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function(data, filter): boolean {
      let searchStrings = JSON.parse(filter);
      return data.filename.toLowerCase().indexOf(searchStrings.filename) !== -1
      && data.dateTime.toLowerCase().indexOf(searchStrings.dateTime) !== -1
      && data.message.toLowerCase().indexOf(searchStrings.message) !== -1
    };
    return filterFunction;
  }
 



}
